import { render } from "./2Factor.vue?vue&type=template&id=35196934"
import script from "./2Factor.vue?vue&type=script&lang=js"
export * from "./2Factor.vue?vue&type=script&lang=js"

import "./2Factor.vue?vue&type=style&index=0&id=35196934&lang=css"

import exportComponent from "/codebuild/output/src2917665834/src/pos-user-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__